import { tailorSchemas } from '../../../tailor'
import { computers1Fit } from './section-fit'
import { lightings1BaseSchemas } from '../../lightings/lightings-1/builder-schemas'
import { catalogueSchemas } from './sections/catalogue'
import { schema as footerSchema } from './sections/footer/footer.schema'
import { schema as headerSchema } from './sections/header/header.schema'
import { homeSchemas } from './sections/home'
import { purchaseSchemas } from './sections/purchase'

/**
 * Projukti (computers-1), the computer-shop design (docs/THEME_COMPUTERS_1_PLAN.md). It renders the shared section types
 * with its own markup (storefront-nuxt `sections/<type>/themes/computers-1.vue`) and adds the home sections it shares
 * with the Cares designs; the shared schemas keep stored data portable between themes.
 */
export const computers1Schemas = tailorSchemas({
  ...lightings1BaseSchemas,
  componentSchemas: {
    ...lightings1BaseSchemas.componentSchemas,
    ...homeSchemas,
    ...catalogueSchemas,
    ...purchaseSchemas,
  },
  headerSchema,
  footerSchema,
}, computers1Fit)
